export class ServiceProviderPermission {
    public static readonly search: string =
        'serviceproviders:search:service-providers';
    public static readonly add: string =
        'serviceproviders:add:service-provider';
    public static readonly read: string =
        'serviceproviders:read:service-provider';
    public static readonly update: string =
        'serviceproviders:update:service-provider';
    public static readonly addBankAccount: string =
        'serviceproviders:add:bank-account';
    public static readonly readBankAccount: string =
        'serviceproviders:read:bank-account';
    public static readonly updateBankAccount: string =
        'serviceproviders:update:bank-account';
    public static readonly addDocument: string =
        'serviceproviders:add:document';
    public static readonly readDocument: string =
        'serviceproviders:read:document';
    public static readonly downloadDocument: string =
        'serviceproviders:download:document';
    public static readonly viewDocument: string =
        'serviceproviders:view:document';
    public static readonly searchAreas: string =
        'serviceproviders:search:areas';
    public static readonly readTypes: string = 'serviceproviders:read:types';
}
